/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Insert_Marker_CommentInputs */



/**
* | output |
* | --- |
* | "Insert a new marker into the selected marker list at the current time and prompt for a comment" |
*
* @param {Shortcut_Keys_Desc_Insert_Marker_CommentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_insert_marker_comment = /** @type {((inputs?: Shortcut_Keys_Desc_Insert_Marker_CommentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Insert_Marker_CommentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Insérer un nouveau marqueur dans la liste de marqueurs sélectionnée à l'heure actuelle et demander un commentaire")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuen Marker in die ausgewählte Marker-Liste zur aktuellen Zeit einfügen und nach einem Kommentar fragen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci un nuovo marcatore nell'elenco marcatori selezionato all'ora corrente e richiedi un commento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить новый маркер в выбранный список маркеров в текущее время и запросить комментарий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar un nuevo marcador en la lista de marcadores seleccionada a la hora actual y solicitar un comentario")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在当前时间向所选标记列表插入新标记并提示输入注释")
	if (locale === "ja") return /** @type {LocalizedString} */ ("現在の時刻で選択中のマーカーリストに新しいマーカーを挿入し、コメントの入力を求める")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वर्तमान समय पर चयनित मार्कर सूची में नया मार्कर डालें और टिप्पणी के लिए संकेत दें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir um novo marcador na lista de marcadores selecionada na hora atual e pedir um comentário")
	return /** @type {LocalizedString} */ ("Insert a new marker into the selected marker list at the current time and prompt for a comment")
});